import { render, staticRenderFns } from "./container.vue?vue&type=template&id=78018788&scoped=true"
import script from "./container.vue?vue&type=script&lang=js"
export * from "./container.vue?vue&type=script&lang=js"
import style0 from "./container.vue?vue&type=style&index=0&id=78018788&prod&lang=scss&scoped=true"
import style1 from "./container.vue?vue&type=style&index=1&id=78018788&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78018788",
  null
  
)

export default component.exports